import React, { useState, useRef, useEffect, ReactNode } from 'react';
import { Context, usePlayerContext } from '../Context';
const Tooltip = ({
  position,
  children,
  tooltipText,
  componentName,
}: {
  position: string;
  children: ReactNode;
  tooltipText: string;
  componentName: string;
}) => {
  const { sdk } = usePlayerContext();

  const [visible, setVisible] = useState(false);
  const [tooltipClass, setTooltipClass] = useState('center');
  const tooltipRef = useRef<HTMLDivElement>(null);
  const childRef = useRef<HTMLElement>(null);

  const showTimeoutRef = useRef<number | null>(null);
  const hideTimeoutRef = useRef<number | null>(null);

  const showTooltip = () => {
    if (hideTimeoutRef.current) {
      clearTimeout(hideTimeoutRef.current);
      hideTimeoutRef.current = null;
    }
    if (childRef.current) {
      childRef.current.setAttribute('data-title', tooltipText);
      //childRef.current.removeAttribute('title');
    }
    showTimeoutRef.current = window.setTimeout(() => {
      setVisible(true);
    }, 300);
  };

  const hideTooltip = () => {
    if (showTimeoutRef.current) {
      clearTimeout(showTimeoutRef.current);
      showTimeoutRef.current = null;
    }
    if (childRef.current) {
      //childRef.current.setAttribute('title', tooltipText);
      childRef.current.removeAttribute('data-title');
    }
    hideTimeoutRef.current = window.setTimeout(() => {
      setVisible(false);
    }, 300);
  };

  useEffect(() => {
    if (!visible) {
      setTimeout(() => {
        setTooltipClass('');
      }, 300);
      return;
    }

    let newTooltipClass;
    if (tooltipRef.current) {
      const tooltipRect = tooltipRef.current.getBoundingClientRect();
      const parentRect = sdk.element.getBoundingClientRect();

      if (tooltipRect.right > parentRect.right) {
        newTooltipClass = ' ' + sdk.getClassNamePrefix() + '-tooltip-left';
      } else if (tooltipRect.left - tooltipRect.width / 2 < parentRect.left) {
        newTooltipClass = ' ' + sdk.getClassNamePrefix() + '-tooltip-right';
      } else
        newTooltipClass = ' ' + sdk.getClassNamePrefix() + '-tooltip-center';

      if (tooltipRect.top < parentRect.top) {
        newTooltipClass += ' ' + sdk.getClassNamePrefix() + '-tooltip-bottom';
      }

      setTooltipClass(newTooltipClass);
    }
  }, [visible]);

  return (
    <div
      data-componentname={componentName}
      className={`${sdk.getClassNamePrefix()}-tooltip-container`}
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
      onClick={hideTooltip}
      onKeyDown={() => {}}
      role="button"
      //tabIndex={1}
    >
      {React.cloneElement(children as React.ReactElement<any>, {
        ref: childRef,
      })}
      <div
        ref={tooltipRef}
        className={`${sdk.getClassNamePrefix()}-tooltip ${sdk.getClassNamePrefix()}-tooltip-${position} ${tooltipClass} ${sdk.getClassNamePrefix()}-tooltip-${visible ? 'fadeIn' : 'fadeOut'}`}
      >
        {tooltipText}
      </div>
    </div>
  );
};

export default Tooltip;
